import { get } from 'lodash-es';
import { isArray } from '@mts-fe/utils';
import { t } from '@mts/hooks/web/useI18n';
import type { BasicColumn, BasicTableProps, ColumnOptionsType } from './types/table';
import { ROW_KEY } from './const';

export const SLOT_FORM_REG = /form-/;

export function getDataIndex(dataIndex: BasicColumn['dataIndex']) {
  return isArray(dataIndex) ? dataIndex.join('.') : dataIndex?.toString() || '';
}

/** 获取表格列的缓存信息 */
export function getTableColumnCache(col: BasicColumn): ColumnOptionsType {
  return {
    langKey: col.dataLangKey,
    label:
      typeof col.title === 'string'
        ? col.title
        : typeof col.customTitle === 'string'
          ? col.customTitle
          : '',
    value: getDataIndex(col.dataIndex) || (col.title || '').toString(),
    column: {
      cacheHidden: col.cacheHidden,
      defaultHidden: col.defaultHidden,
    },
    fixed: col.fixed,
    width: col.width,
  };
}

export function groupByGroupTitle(columns: BasicColumn[]): BasicColumn[] {
  const groupMap = new Map<string, BasicColumn[]>();
  const order: Array<{ kind: 'group'; key: string } | { kind: 'single'; item: BasicColumn }> = [];

  for (let i = 0; i < columns.length; i++) {
    const item = { ...columns[i] };
    const key = item.groupTitle;
    if (key) {
      let group = groupMap.get(key);
      if (!group) {
        group = [];
        groupMap.set(key, group);
        order.push({ kind: 'group', key });
      }
      item.groupTitle = void 0;
      group.push(item);
    } else {
      order.push({ kind: 'single', item });
    }
  }

  const result: BasicColumn[] = [];
  for (const entry of order) {
    if (entry.kind === 'single') {
      result.push(entry.item);
    } else {
      const { key } = entry;
      result.push({ key, title: t(key), align: 'center', children: groupMap.get(key) });
    }
  }
  return result;
}

export function parseRowKey<RecordType = any>(
  rowKey: BasicTableProps['rowKey'],
  record: RecordType,
  autoCreateKey?: boolean,
): number | string {
  if (autoCreateKey) {
    return ROW_KEY;
  } else {
    if (typeof rowKey === 'string') {
      return rowKey;
    } else if (rowKey) {
      return rowKey(record);
    } else {
      return ROW_KEY;
    }
  }
}

export function parseRowKeyValue<RecordType = any>(
  rowKey: BasicTableProps['rowKey'],
  record: RecordType,
  autoCreateKey?: boolean,
): number | string {
  return get(record, parseRowKey(rowKey, record, autoCreateKey));
}
